export default "https://dakcheck.solease.nl/static/media/comunity.e9dc10d4.svg";